/*
 * KULT Warenkorb: Geschenk-Staffel, Fortschrittsbalken, Vorschläge, Rabattcode.
 * Ersetzt UpCart und CandyRack. Daten: window.KULT.cart aus snippets/kult-cart-config.liquid.
 * Ablauf: Warenkorb lesen → passendes Geschenkpaket bestimmen → Paket tauschen/entfernen →
 * prüfen, ob es wirklich gratis ist → Impulse-Warenkorb neu aufbauen (cart:build) → Anzeige rendern.
 */
(function () {
  'use strict';

  var KULT = (window.KULT = window.KULT || {});
  var CFG = KULT.cart || { geschenke: [], vorschlaege: [], versandfrei: null };
  var RATE = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
  var GESCHENKE = (CFG.geschenke || []).filter(function (g) { return g.variantId && g.schwelle > 0; })
    .sort(function (a, b) { return a.schwelle - b.schwelle; });
  var GESCHENK_IDS = GESCHENKE.map(function (g) { return g.variantId; });

  var state = { cart: null, busy: false, queued: null, lastTier: null, gesperrt: {}, hinweis: null, ready: false };

  /* ---------- Hilfen ---------- */
  function geld(cents) {
    try { return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function lokal(shopCents) { return Math.round(shopCents * RATE); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function istGeschenk(item) {
    return item.product_type === 'Geschenk' || GESCHENK_IDS.indexOf(item.variant_id) !== -1;
  }
  function warenwert(cart) {
    return (cart.items || []).reduce(function (sum, it) {
      if (istGeschenk(it) || it.gift_card) return sum;
      return sum + (it.original_line_price || 0);
    }, 0);
  }
  function codes(cart) { return (cart && cart.discount_codes) || []; }
  function stufeFuer(wert) {
    var treffer = null;
    GESCHENKE.forEach(function (g) {
      if (wert >= lokal(g.schwelle) && !state.gesperrt[g.variantId]) treffer = g;
    });
    return treffer;
  }
  function naechste(wert) {
    for (var i = 0; i < GESCHENKE.length; i++) if (wert < lokal(GESCHENKE[i].schwelle)) return GESCHENKE[i];
    return null;
  }
  function holen() {
    return fetch('/cart.js?kult=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function senden(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function neuAufbauen() { document.dispatchEvent(new CustomEvent('cart:build')); }

  /* ---------- Abgleich ---------- */
  async function abgleich(grund, neuErzwingen) {
    if (neuErzwingen) state.neuNoetig = true;
    if (state.busy) { state.queued = grund || 'nachlauf'; return; }
    state.busy = true;
    var geaendert = false;
    try {
      var cart = await holen();
      for (var runde = 0; runde < 4; runde++) {
        var geschenke = cart.items.filter(istGeschenk);
        var aktiveCodes = codes(cart);

        // Ein eingegebener Code hat Vorrang: Geschenkpakete sind nicht kombinierbar.
        if (aktiveCodes.length) {
          if (geschenke.length) {
            // Über die Varianten-ID statt den Zeilen-Key: Shopify ändert Keys, sobald ein Rabatt greift oder wegfällt.
            var weg = {};
            geschenke.forEach(function (g) { weg[g.variant_id] = 0; });
            cart = await senden('/cart/update.js', { updates: weg });
            geaendert = true;
            continue;
          }
          var ungueltig = aktiveCodes.filter(function (c) { return c.applicable === false; });
          if (ungueltig.length) {
            state.hinweis = { art: 'fehler', text: 'Der Code ' + ungueltig.map(function (c) { return c.code; }).join(', ') + ' ist nicht gültig oder gilt nicht für diesen Warenkorb.' };
            cart = await senden('/cart/update.js', { discount: aktiveCodes.filter(function (c) { return c.applicable !== false; }).map(function (c) { return c.code; }).join(',') });
            geaendert = true;
            continue;
          }
          break;
        }

        var soll = stufeFuer(warenwert(cart));
        var updates = {}, noetig = false;
        var mengen = {};
        geschenke.forEach(function (g) { mengen[g.variant_id] = (mengen[g.variant_id] || 0) + g.quantity; });
        Object.keys(mengen).forEach(function (k) {
          var vid = parseInt(k, 10);
          if (soll && vid === soll.variantId) {
            if (mengen[k] !== 1) { updates[vid] = 1; noetig = true; }
          } else { updates[vid] = 0; noetig = true; }
        });
        if (soll && !mengen[soll.variantId]) { updates[soll.variantId] = 1; noetig = true; }
        if (!noetig) {
          // Prüfen, ob das Paket wirklich gratis ist (Rundung bei Fremdwährung, Rabatt nicht aktiv).
          var zeile = soll && cart.items.filter(function (i) { return i.variant_id === soll.variantId; })[0];
          if (zeile && zeile.final_line_price > 0) {
            state.gesperrt[soll.variantId] = true;
            continue;
          }
          break;
        }
        cart = await senden('/cart/update.js', { updates: updates });
        geaendert = true;
      }
      var vorher = state.lastTier;
      state.cart = cart;
      var jetzt = cart.items.filter(istGeschenk)[0];
      var jetztSchwelle = jetzt ? (GESCHENKE.filter(function (g) { return g.variantId === jetzt.variant_id; })[0] || {}).schwelle : 0;
      if (state.ready && grund !== 'start' && jetztSchwelle && (vorher === null || jetztSchwelle > vorher)) state.frisch = jetztSchwelle;
      state.lastTier = jetztSchwelle || 0;
      state.ready = true;
    } catch (e) {
      if (window.console) console.warn('KULT Warenkorb', e);
    } finally {
      state.busy = false;
      if (geaendert || state.neuNoetig) { state.neuNoetig = false; neuAufbauen(); }
      allesZeichnen();
      if (state.queued) { var q = state.queued; state.queued = null; abgleich(q); }
    }
  }

  /* ---------- Anzeige ---------- */
  function stationen() {
    var s = [];
    if (CFG.versandfrei) s.push({ wert: CFG.versandfrei, art: 'versand', label: 'Versand frei' });
    GESCHENKE.forEach(function (g) { s.push({ wert: g.schwelle, art: 'geschenk', label: 'Geschenk', g: g }); });
    return s.sort(function (a, b) { return a.wert - b.wert; });
  }
  function fuellung(wert, st) {
    var n = st.length;
    if (!n) return 0;
    for (var i = 0; i < n; i++) {
      var ziel = lokal(st[i].wert), start = i ? lokal(st[i - 1].wert) : 0;
      if (wert < ziel) return ((i + (wert - start) / (ziel - start)) / n) * 100;
    }
    return 100;
  }
  function neueTeile(g) {
    var vorher = null;
    GESCHENKE.forEach(function (x) { if (x.schwelle < g.schwelle) vorher = x; });
    var alt = vorher ? (vorher.inhalt || []).map(function (i) { return i.artikel; }) : [];
    return (g.inhalt || []).filter(function (i) { return alt.indexOf(i.artikel) === -1; });
  }
  function bildFuer(g, artikel) {
    var teil = (g.inhalt || []).filter(function (x) { return x.artikel === artikel && x.bild; })[0];
    return teil ? teil.bild : g.bild;
  }

  function fortschrittHtml(cart, kompakt) {
    var wert = warenwert(cart);
    var st = stationen();
    var aktiveCodes = codes(cart);
    var aktuell = cart.items.filter(istGeschenk)[0];
    var aktuellG = aktuell ? GESCHENKE.filter(function (g) { return g.variantId === aktuell.variant_id; })[0] : null;
    var nG = naechste(wert);
    var vfOffen = CFG.versandfrei && wert < lokal(CFG.versandfrei);
    var h = '<div class="kult-prog' + (state.frisch ? ' is-frisch' : '') + '">';

    // Botschaft
    var msg = '';
    if (aktiveCodes.length) {
      msg = 'Code <b>' + esc(aktiveCodes.map(function (c) { return c.code; }).join(', ')) + '</b> ist aktiv. Geschenkpakete sind nicht mit Rabattcodes kombinierbar.';
      var moeglich = stufeFuer(wert);
      if (moeglich) msg += ' <button type="button" class="kult-prog__link" data-kult-code-remove>Code entfernen und Geschenk im Wert von ' + esc(geld(moeglich.wert)) + ' erhalten</button>';
    } else if (state.frisch && aktuellG) {
      msg = '<span class="kult-prog__tag">Freigeschaltet</span> ' + esc(aktuellG.titel) + ' gratis, Wert ' + esc(geld(aktuellG.wert)) + '.';
      if (nG) msg += ' Noch <b>' + esc(geld(lokal(nG.schwelle) - wert)) + '</b> bis zur nächsten Stufe.';
    } else if (vfOffen) {
      msg = 'Noch <b>' + esc(geld(lokal(CFG.versandfrei) - wert)) + '</b> bis zum kostenlosen Versand.';
      if (GESCHENKE[0]) msg += ' Ab ' + esc(geld(lokal(GESCHENKE[0].schwelle))) + ' wartet Ihr erstes Geschenk.';
    } else if (!aktuellG && nG) {
      msg = (CFG.versandfrei ? 'Versand gratis. ' : '') + 'Noch <b>' + esc(geld(lokal(nG.schwelle) - wert)) + '</b> bis zu Ihrem ersten Geschenk.';
    } else if (aktuellG && nG) {
      msg = 'Ihr ' + esc(aktuellG.titel) + ' ist gratis dabei (Wert ' + esc(geld(aktuellG.wert)) + '). Noch <b>' + esc(geld(lokal(nG.schwelle) - wert)) + '</b> bis zur nächsten Stufe.';
    } else if (aktuellG && !nG) {
      msg = 'Höchste Stufe erreicht: ' + esc(aktuellG.titel) + ' gratis, Wert ' + esc(geld(aktuellG.wert)) + '.';
    }
    h += '<p class="kult-prog__msg" aria-live="polite">' + msg + '</p>';

    // Balken mit Stationen
    var f = fuellung(wert, st);
    h += '<div class="kult-prog__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(f) + '" aria-label="Fortschritt bis zu Versand frei und Geschenken">';
    h += '<div class="kult-prog__fill" style="width:' + f.toFixed(1) + '%"></div>';
    h += '<ol class="kult-prog__stops">';
    st.forEach(function (s, i) {
      var erreicht = wert >= lokal(s.wert) && !(s.art === 'geschenk' && aktiveCodes.length);
      var pos = ((i + 1) / st.length) * 100;
      h += '<li class="kult-prog__stop' + (erreicht ? ' is-done' : '') + (s.art === 'versand' ? ' is-versand' : '') + '" style="left:' + pos.toFixed(2) + '%">' +
        '<span class="kult-prog__dot" aria-hidden="true"></span>' +
        '<span class="kult-prog__lbl">' + esc(geld(lokal(s.wert)).replace(/[,.]00(?=\D*$)/, '')) + '</span></li>';
    });
    h += '</ol></div>';

    // Nächstes Geschenk als Vorschau (in der Schublade als eine Zeile)
    if (!aktiveCodes.length && nG) {
      var teile = neueTeile(nG);
      if (kompakt) {
        h += '<p class="kult-prog__nextline">Ab ' + esc(geld(lokal(nG.schwelle))) + ' gratis dazu: ' +
          esc(teile.map(function (t) { return t.artikel; }).join(', ')) + ' <span>(Paketwert ' + esc(geld(nG.wert)) + ')</span></p>';
      } else {
        h += '<div class="kult-prog__next"><p class="kult-prog__nexttitle">Ab ' + esc(geld(lokal(nG.schwelle))) + ' gratis dazu' +
          ' <span class="kult-prog__wert">Paketwert ' + esc(geld(nG.wert)) + '</span></p><ul class="kult-prog__teile">';
        teile.forEach(function (t) {
          h += '<li><img src="' + esc(bildFuer(nG, t.artikel)) + '" alt="" width="56" height="56" loading="lazy"><span>' + esc(t.artikel) + '</span></li>';
        });
        h += '</ul></div>';
      }
    }
    h += '</div>';
    return h;
  }

  /* Vorschläge und Bedingungen: unter den Artikeln, damit diese auf dem Handy sichtbar bleiben */
  function vorschlagHtml(cart, max) {
    var wert = warenwert(cart);
    var aktiveCodes = codes(cart);
    var nG = naechste(wert);
    var vfOffen = CFG.versandfrei && wert < lokal(CFG.versandfrei);
    var h = '<div class="kult-sugg">';
    var ziel = vfOffen ? lokal(CFG.versandfrei) : (nG ? lokal(nG.schwelle) : 0);
    if (ziel && !aktiveCodes.length) {
      var luecke = ziel - wert;
      var drin = (cart.items || []).map(function (i) { return i.product_id; });
      var kandidaten = (CFG.vorschlaege || []).filter(function (v) { return drin.indexOf(v.productId) === -1 && v.variantId; });
      var passend = kandidaten.filter(function (v) { return v.preis >= luecke; }).sort(function (a, b) { return a.preis - b.preis; });
      var rest = kandidaten.filter(function (v) { return v.preis < luecke; }).sort(function (a, b) { return b.preis - a.preis; });
      var auswahl = passend.concat(rest).slice(0, max);
      if (auswahl.length) {
        h += '<p class="kult-sugg__title">' + (passend.length ? (vfOffen ? 'Damit ist der Versand kostenlos' : 'Damit erreichen Sie die nächste Geschenkstufe') : 'Passt dazu') + '</p><ul>';
        auswahl.forEach(function (v) {
          h += '<li><a href="' + esc(v.url) + '" class="kult-sugg__img"><img src="' + esc(v.bild) + '" alt="" width="64" height="64" loading="lazy"></a>' +
            '<span class="kult-sugg__text"><a href="' + esc(v.url) + '">' + esc(v.titel) + '</a>' + (v.variante ? '<small>' + esc(v.variante) + '</small>' : '') +
            '<b>' + esc(geld(v.preis)) + '</b></span>' +
            '<button type="button" class="kult-sugg__add" data-kult-add="' + v.variantId + '" aria-label="' + esc(v.titel) + ' in den Warenkorb">+ Hinzufügen</button></li>';
        });
        h += '</ul>';
      }
    }
    h += '<p class="kult-sugg__fine">Geschenke gelten je Bestellung für die höchste erreichte Stufe (Warenwert ohne Versand), solange der Vorrat reicht. Nicht mit Rabattcodes kombinierbar.</p>';
    h += '</div>';
    return h;
  }

  function codeBereich(cart) {
    document.querySelectorAll('[data-kult-code]').forEach(function (box) {
      var msg = box.querySelector('[data-kult-code-msg]');
      if (!msg) return;
      var aktive = codes(cart).filter(function (c) { return c.applicable !== false; });
      if (state.hinweis && state.hinweis.art === 'fehler') {
        msg.innerHTML = esc(state.hinweis.text);
        msg.className = 'kult-code__note is-fehler';
      } else if (aktive.length) {
        msg.innerHTML = 'Aktiv: <b>' + esc(aktive.map(function (c) { return c.code; }).join(', ')) + '</b> · <button type="button" class="kult-prog__link" data-kult-code-remove>entfernen</button>';
        msg.className = 'kult-code__note is-aktiv';
      } else {
        msg.innerHTML = 'Rabattcodes sind nicht mit Geschenkpaketen kombinierbar.';
        msg.className = 'kult-code__note';
      }
    });
  }

  function allesZeichnen() {
    if (!state.cart) return;
    var leer = !state.cart.item_count || !stationen().length;
    document.querySelectorAll('[data-kult-progress], [data-kult-sugg]').forEach(function (el) {
      // Immer als gerendert markieren, sonst zeichnet der MutationObserver endlos neu.
      el.setAttribute('data-kult-rendered', '1');
      if (leer) { if (el.innerHTML) el.innerHTML = ''; el.hidden = true; return; }
      var inSchublade = !!el.closest('#CartDrawer, .drawer');
      el.hidden = false;
      el.innerHTML = el.hasAttribute('data-kult-sugg') ? vorschlagHtml(state.cart, inSchublade ? 1 : 3) : fortschrittHtml(state.cart, inSchublade);
    });
    codeBereich(state.cart);
    if (state.frisch) setTimeout(function () { state.frisch = null; }, 4000);
    produktHinweise(state.cart);
  }

  /* Hinweis auf Produktseiten: „Mit diesem Artikel …“ */
  function produktHinweise(cart) {
    document.querySelectorAll('[data-kult-pdp-hint]').forEach(function (el) {
      var preis = parseInt(el.getAttribute('data-preis'), 10) || 0;
      var wert = warenwert(cart);
      if (codes(cart).length || !stationen().length) { el.innerHTML = ''; return; }
      var nachher = wert + preis;
      var text = '';
      if (CFG.versandfrei && wert < lokal(CFG.versandfrei)) {
        text = nachher >= lokal(CFG.versandfrei)
          ? 'Mit diesem Artikel ist der Versand für Sie kostenlos.'
          : 'Mit diesem Artikel fehlen nur noch ' + esc(geld(lokal(CFG.versandfrei) - nachher)) + ' bis zum kostenlosen Versand.';
      } else {
        var n = naechste(wert);
        if (!n) text = 'Ihr Warenkorb hat die höchste Geschenkstufe erreicht.';
        else if (nachher >= lokal(n.schwelle)) text = 'Mit diesem Artikel erhalten Sie ein Geschenkpaket im Wert von ' + esc(geld(n.wert)) + ' gratis.';
        else text = 'Mit diesem Artikel fehlen nur noch ' + esc(geld(lokal(n.schwelle) - nachher)) + ' bis zum Geschenkpaket im Wert von ' + esc(geld(n.wert)) + '.';
      }
      el.innerHTML = text;
    });
  }
  // Variantenwechsel (Impulse): Preis im Hinweis nachziehen.
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('[data-kult-pdp-hint]').forEach(function (el) {
      var form = el.closest('form');
      if (form && form.querySelector('option[value="' + v.id + '"]')) el.setAttribute('data-preis', v.price);
    });
    if (state.cart) produktHinweise(state.cart);
  });

  /* ---------- Lieferdatum auf der Produktseite (DE, AT, CH) ----------
   * Versand am selben Werktag bei Bestellung bis 12 Uhr (Eckental), sonst am nächsten Werktag.
   * Laufzeit DHL ab Versandtag: DE 1–2, AT 2–4, CH 2–4 Werktage (ergibt 1–3, 2–5, 2–5 ab Bestellung).
   * KULT Release 2 (29.10.2026): AT von 2–3 auf 2–4 (E133: Österreich gesamt 2–5 Werktage, gleich wie transitTime im Schema).
   * KULT Release 2 (29.10.2026): „Lieferung in die Schweiz“ statt „Lieferung nach die Schweiz“.
   * Werktage Mo–Fr ohne bayerische Feiertage (Mariä Himmelfahrt gilt in Eckental nicht).
   */
  var LAUFZEIT = { DE: [1, 2], AT: [2, 4], CH: [2, 4] };
  var LANDNAME = { DE: 'Deutschland', AT: 'Österreich', CH: 'die Schweiz' };
  function ostern(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(j, monat - 1, tag);
  }
  var feiertagCache = {};
  function feiertage(j) {
    if (feiertagCache[j]) return feiertagCache[j];
    var T = 86400000, o = ostern(j), s = {};
    [[0, 1], [0, 6], [4, 1], [9, 3], [10, 1], [11, 24], [11, 25], [11, 26], [11, 31]].forEach(function (x) { s[Date.UTC(j, x[0], x[1])] = 1; });
    [-2, 1, 39, 50, 60].forEach(function (x) { s[o + x * T] = 1; });
    return (feiertagCache[j] = s);
  }
  function werktag(utc) {
    var d = new Date(utc), wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && !feiertage(d.getUTCFullYear())[utc];
  }
  function plusWerktage(utc, n) {
    var T = 86400000, d = utc;
    while (n > 0) { d += T; if (werktag(d)) n--; }
    return d;
  }
  function jetztBerlin() {
    var teile = {};
    new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { teile[p.type] = p.value; });
    return { tag: Date.UTC(+teile.year, +teile.month - 1, +teile.day), stunde: +teile.hour % 24 };
  }
  function datumText(utc) {
    return new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit' }).format(new Date(utc));
  }
  function lieferdatum() {
    var land = CFG.land, lz = LAUFZEIT[land];
    document.querySelectorAll('[data-kult-lieferung]').forEach(function (el) {
      if (!lz || el.getAttribute('data-verfuegbar') === 'false') { el.hidden = true; return; }
      var j = jetztBerlin();
      var heute = werktag(j.tag) && j.stunde < 12;
      var versand = heute ? j.tag : plusWerktage(j.tag, 1);
      var von = plusWerktage(versand, lz[0]), bis = plusWerktage(versand, lz[1]);
      el.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20"><path fill="none" stroke="currentColor" stroke-width="1.8" d="M2 6h11v9H2zM13 9h4l3 3v3h-7zM6 18.5a1.5 1.5 0 1 0 0-.01M17 18.5a1.5 1.5 0 1 0 0-.01"/></svg>' +
        '<span><b>' + (land === 'CH' ? 'Lieferung in ' : 'Lieferung nach ') + esc(LANDNAME[land]) + ': ' + esc(datumText(von)) + '–' + esc(datumText(bis)) + '</b>' +
        '<small>' + (heute ? 'Bestellung bis 12 Uhr: Versand heute mit DHL.' : 'Versand am ' + esc(datumText(versand)) + ' mit DHL.') + '</small></span>';
      el.hidden = false;
    });
  }
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('[data-kult-lieferung]').forEach(function (el) {
      var form = el.closest('form');
      if (form && form.querySelector('option[value="' + v.id + '"]')) el.setAttribute('data-verfuegbar', v.available ? 'true' : 'false');
    });
    lieferdatum();
  });

  /* ---------- Menge und Entfernen nach Variante ----------
   * Shopify teilt Zeilen, sobald der Geschenk-Rabatt nur einen Teil der Menge braucht, und ändert dabei
   * die Zeilen-Keys. Das Theme schickt Mengen mit dem Key aus der Anzeige; ist er veraltet, lehnt Shopify
   * die Änderung ab. Deshalb übernimmt dieses Skript Menge und Entfernen für Zeilen mit data-kult-variant:
   * frischen Warenkorb holen, die ganze Menge auf die erste Zeile legen, die übrigen Zeilen auf 0.
   */
  async function mengeSetzen(variantId, neu, wrap) {
    if (wrap) wrap.classList.add('is-loading');
    try {
      var cart = await holen();
      var zeilen = cart.items.filter(function (i) { return i.variant_id === variantId && !istGeschenk(i) && !(i.properties && Object.keys(i.properties).length); });
      if (!zeilen.length) return;
      var updates = {};
      zeilen.forEach(function (z, idx) { updates[z.key] = idx === 0 ? Math.max(0, neu) : 0; });
      await senden('/cart/update.js', { updates: updates });
    } catch (e) {
      if (window.console) console.warn('KULT Menge', e);
    } finally {
      await abgleich('menge', true);
      if (wrap) wrap.classList.remove('is-loading');
    }
  }
  function zeileVon(el) { return el && el.closest && el.closest('[data-kult-variant]'); }
  var mengenTimer = {};
  function mengeSpaeter(vid, input, wrap) {
    // Schnelle Klicks auf +/− bündeln: nur der letzte Stand geht an Shopify.
    clearTimeout(mengenTimer[vid]);
    if (wrap) wrap.classList.add('is-loading');
    mengenTimer[vid] = setTimeout(function () { mengeSetzen(vid, parseInt(input.value, 10) || 0, wrap); }, 350);
  }
  // Erfassungsphase: vor den Klick-Handlern des Themes (QtySelector) eingreifen.
  window.addEventListener('click', function (e) {
    var zeile = zeileVon(e.target);
    if (!zeile) return;
    var vid = parseInt(zeile.getAttribute('data-kult-variant'), 10);
    var btn = e.target.closest('.js-qty__adjust, [data-kult-remove]');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var input = zeile.querySelector('.js-qty__num');
    var wrap = zeile.querySelector('.js-qty__wrapper');
    var jetzt = parseInt(input && input.value, 10) || 0;
    var neu = btn.hasAttribute('data-kult-remove') ? 0 : (btn.classList.contains('js-qty__adjust--plus') ? jetzt + 1 : jetzt - 1);
    if (neu < 0) neu = 0;
    if (input) input.value = neu;
    if (neu === 0 || !input) { clearTimeout(mengenTimer[vid]); mengeSetzen(vid, neu, wrap); }
    else mengeSpaeter(vid, input, wrap);
  }, true);
  window.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('.js-qty__num')) return;
    var zeile = zeileVon(e.target);
    if (!zeile) return;
    e.stopImmediatePropagation();
    var neu = parseInt(e.target.value, 10);
    if (isNaN(neu) || neu < 0) neu = 1;
    e.target.value = neu;
    mengeSetzen(parseInt(zeile.getAttribute('data-kult-variant'), 10), neu, zeile.querySelector('.js-qty__wrapper'));
  }, true);

  /* ---------- Ereignisse ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-kult-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true; add.textContent = '…';
      senden('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-kult-add'), 10), quantity: 1 }] })
        .then(function () { return abgleich('vorschlag'); })
        .then(neuAufbauen);
      return;
    }
    var apply = e.target.closest('[data-kult-code-apply]');
    if (apply) {
      e.preventDefault();
      var box = apply.closest('[data-kult-code]');
      var input = box && box.querySelector('[data-kult-code-input]');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      apply.disabled = true;
      state.hinweis = null;
      var bisher = codes(state.cart).map(function (c) { return c.code; });
      if (bisher.indexOf(code) === -1) bisher.push(code);
      senden('/cart/update.js', { discount: bisher.join(',') })
        .then(function () { if (input) input.value = ''; return abgleich('code'); })
        .then(function () { apply.disabled = false; neuAufbauen(); });
      return;
    }
    var klappe = e.target.closest('[data-kult-code-toggle]');
    if (klappe) {
      var kbox = klappe.closest('[data-kult-code]');
      var inhalt = kbox && kbox.querySelector('.kult-code__box');
      if (inhalt) {
        var offen = inhalt.hidden;
        inhalt.hidden = !offen;
        klappe.setAttribute('aria-expanded', offen ? 'true' : 'false');
        kbox.classList.toggle('is-offen', offen);
        if (offen) { var f = inhalt.querySelector('input'); if (f) f.focus(); }
      }
      return;
    }
    var rm = e.target.closest('[data-kult-code-remove]');
    if (rm) {
      e.preventDefault();
      state.hinweis = null;
      senden('/cart/update.js', { discount: '' }).then(function () { return abgleich('code-weg'); }).then(neuAufbauen);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-kult-code-input]')) {
      e.preventDefault();
      var btn = e.target.closest('[data-kult-code]').querySelector('[data-kult-code-apply]');
      if (btn) btn.click();
    }
  });
  document.addEventListener('ajaxProduct:added', function () { abgleich('hinzugefuegt'); });
  document.addEventListener('cart:updated', function () { abgleich('geaendert'); });

  // Impulse ersetzt den Warenkorb-Inhalt nach jedem Neuaufbau: Platzhalter sofort wieder füllen.
  var mo = new MutationObserver(function () {
    if (!state.cart) return;
    if (document.querySelector('[data-kult-progress]:not([data-kult-rendered]), [data-kult-sugg]:not([data-kult-rendered])')) allesZeichnen();
  });
  // Schnellansicht (Impulse) lädt das Produktformular nach: Lieferzeile und Hinweis füllen.
  document.addEventListener('quickview:loaded', function () {
    lieferdatum();
    if (state.cart) produktHinweise(state.cart);
  });
  function start() {
    mo.observe(document.body, { childList: true, subtree: true });
    lieferdatum();
    abgleich('start');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  KULT.warenkorb = { abgleich: abgleich, state: state, lieferdatum: lieferdatum, _plusWerktage: plusWerktage, _werktag: werktag };
})();
